// Draws bombers (wide hull) and satellites (diamond) traversing the sky, using
// the wave-cycled enemy colour so flyers shift palette with the rest of the world.

import type { GameState } from '../core';
import type { WavePalette } from './palette';

type Ctx = CanvasRenderingContext2D;

const SATELLITE_COLOR = '#b18cff';

export function drawFlying(ctx: Ctx, state: GameState, pal: WavePalette): void {
  for (const f of state.flyingObjects) {
    const { x, y } = f.pos;
    if (f.kind === 'bomber') {
      ctx.fillStyle = pal.enemy;
      ctx.fillRect(x - 16, y - 5, 32, 10);
      ctx.fillRect(x - 6, y - 9, 12, 4);
    } else {
      ctx.fillStyle = SATELLITE_COLOR;
      ctx.beginPath();
      ctx.moveTo(x, y - 8);
      ctx.lineTo(x + 8, y);
      ctx.lineTo(x, y + 8);
      ctx.lineTo(x - 8, y);
      ctx.closePath();
      ctx.fill();
    }
  }
}
